export default __webpack_public_path__ + "static/media/HSExp.0f5a8e78.md";